import { DropdownDrawer, DropdownScrollContainer, Group, Label, Option, TestableProps } from '@tlx/atlas';
import { useIntl } from 'react-intl';
import React from 'react';
import { Month } from '../hooks/useSalarySettings';
import { ValidatedDropdown } from './ValidatedForm/ValidatedDropdown';

export function useMonths(): Record<Month, string> {
    const intl = useIntl();
    return {
        NOT_CHOSEN: intl.formatMessage({ id: 'option_not_chosen' }),
        JANUARY: intl.formatMessage({ id: 'month_first_upper_1' }),
        FEBRUARY: intl.formatMessage({ id: 'month_first_upper_2' }),
        MARCH: intl.formatMessage({ id: 'month_first_upper_3' }),
        APRIL: intl.formatMessage({ id: 'month_first_upper_4' }),
        MAY: intl.formatMessage({ id: 'month_first_upper_5' }),
        JUNE: intl.formatMessage({ id: 'month_first_upper_6' }),
        JULY: intl.formatMessage({ id: 'month_first_upper_7' }),
        AUGUST: intl.formatMessage({ id: 'month_first_upper_8' }),
        SEPTEMBER: intl.formatMessage({ id: 'month_first_upper_9' }),
        OCTOBER: intl.formatMessage({ id: 'month_first_upper_10' }),
        NOVEMBER: intl.formatMessage({ id: 'month_first_upper_11' }),
        DECEMBER: intl.formatMessage({ id: 'month_first_upper_12' }),
    };
}

//TODO: This could probably use <Select> from atlas instead.
export function OnboardingMonthSelect({
    children,
    label,
    ...props
}: {
    label: string;
    defaultValue?: string;
    name: string;
    children?: React.ReactNode;
} & TestableProps) {
    const months = useMonths();
    return (
        <Group className={'atl-inline-block atl-w-full'}>
            <Label>{label}</Label>
            <ValidatedDropdown {...props}>
                <DropdownDrawer>
                    <DropdownScrollContainer>
                        {children ? (
                            <>{children}</>
                        ) : (
                            Object.entries(months).map(([key, value]) => (
                                <Option value={key} key={key}>
                                    {value}
                                </Option>
                            ))
                        )}
                    </DropdownScrollContainer>
                </DropdownDrawer>
            </ValidatedDropdown>
        </Group>
    );
}
